import script from "./BaseSocial.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseSocial.vue?vue&type=script&setup=true&lang=js"

import "./BaseSocial.vue?vue&type=style&index=0&id=162ef044&scoped=true&lang=css"

import exportComponent from "/Users/lulua/Documents/lupanalua_oficial+dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-162ef044"]])

export default __exports__